// extracted by mini-css-extract-plugin
module.exports = {"errors":"styles_errors__f5r_A","success":"styles_success__UZY7i"};